import { FC } from "react"
import { DailyPoint } from "../../../app/reducers/analyticsSlice"
import { LineChart } from "../charts/LineChart"

type ProfitSectionProps = { data: DailyPoint[] }

export const ProfitSection: FC<ProfitSectionProps> = ({ data }) => (
  <div className="chart-wrap">
    <div className="chart-title">Динамика по дням</div>
    <LineChart data={data} />
  </div>
)
